import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppConfigService } from './app-config.service';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxDropDownBoxModule,
  DxDropDownButtonModule,
  DxFormModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTabPanelModule,
  DxTagBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxTooltipModule,
  DxTabsModule,
  DxHtmlEditorModule,
  DxDateBoxModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HeaderComponent } from './sub_components/header/header.component';
import { FooterComponent } from './sub_components/footer/footer.component';
import { LoaderPanelComponent } from './core/interceptors/loader-panel/loader-panel.component';
import { ErrorPopupComponent } from './core/interceptors/error-popup/error-popup.component';
import { HomepageComponent } from './components/homepage/homepage.component';
import { PaginationComponent } from './sub_components/pagination/pagination.component';
import { LanguageInterceptor } from './core/interceptors/language.interceptor';
import { StructureComponent } from './components/structure/structure.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import {
  apiDataFeatureKey,
  apiDataReducer,
  ApiDataEffects,
} from './core/store/api-data';
import { ExcelDatePipe } from './shared/pipes/excel-date/excel-date.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoaderPanelComponent,
    ErrorPopupComponent,
    HomepageComponent,
    PaginationComponent,
    StructureComponent,
    InstructionsComponent,
    ExcelDatePipe,
  ],
  imports: [
    BrowserModule,
    DxButtonModule,
    DxCheckBoxModule,
    RouterModule,
    StoreModule.forRoot({}),
    StoreModule.forFeature(apiDataFeatureKey, apiDataReducer),
    EffectsModule.forRoot([ApiDataEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
      defaultLanguage: 'RU',
    }),
    AppRoutingModule,
    DxTabPanelModule,
    DxFormModule,
    ReactiveFormsModule,
    DxDropDownBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxPopupModule,
    HttpClientModule,
    FormsModule,
    DxTooltipModule,
    DxTagBoxModule,
    DxDropDownButtonModule,
    DxTextAreaModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    DxTabsModule,
    DxHtmlEditorModule,
    DxDateBoxModule,
    DxTreeViewModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigInit,
      multi: true,
      deps: [AppConfigService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

function appConfigInit(appConfigService: AppConfigService) {
  return () => appConfigService.load();
}
